export const textMargin = 8;
